import React, { useCallback } from "react";
import Box from "@mui/material/Box";
import {
  VendorInput,
  VendorOption,
} from "../../../../../../components/input/VendorInput/VendorInput";

interface VendorsFilterProps {
  value: number[];
  onChange: (value: number[]) => void;
}

export const VendorsFilter: React.FC<VendorsFilterProps> = React.memo(
  ({ value, onChange }) => {
    const handleVendorSelect = useCallback(
      (vendors: VendorOption[]) => {
        const vendorIds = vendors.map((v) => Number(v.value));
        onChange(vendorIds);
      },
      [onChange]
    );

    return (
      <Box id="install-vendors-filter" sx={{ mb: 1 }}>
        <VendorInput
          selectedVendorIds={value}
          onVendorsSelect={handleVendorSelect}
        />
      </Box>
    );
  }
);
